import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';

interface Signature {
  Args: {
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}
export default class MiciBaseConsultFormEyeSymptoms extends Component<Signature> {
  clearChangeset = () => {
    if (!this.args.form.changeset.get('eyeSymptoms')) {
      this.args.form.changeset.set('eyeSymptomsRedEye', undefined);
      this.args.form.changeset.set('eyeSymptomsPainful', undefined);
      this.args.form.changeset.set('eyeSymptomsSight', undefined);
    }
  };

  <template>
    <@form.FieldsRadioGroup
      @propertyName='eyeSymptoms'
      @title={{t 'mici-form.eyeSymptoms.long' htmlSafe=true}}
      as |Group|
    >
      <Group.FieldRadio @value={{true}} @label='Oui' />
      <Group.FieldRadio
        @value={{false}}
        @label='Non'
        {{on 'click' this.clearChangeset}}
      />
    </@form.FieldsRadioGroup>
  </template>
}
